import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import liabilityImage from "../../../../../assets/disabilityIcons/liability.svg";
import assetImage from "../../../../../assets/disabilityIcons/asset.png";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { Table } from "antd";
import { MODULE_API } from "../../../../../apis";
import DASHBOARD_API from "../../../../../apis/dashboard.api";
import "./style/assetsandliabilities.css";
import formatAmount from "../../../../../helpers/formatAmount";
export default function AssetsAndLiabilities() {
  const [loading, setLoading] = useState(false);
  const [totalLoan, setTotalLoan] = useState(0);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();
  const [monetaryValue, setMonetaryValue] = useState();
  const [paginatedModule, setPaginatedModule] = useState({
    assetData: {
      currentPage: 1,
      totalPages: 1,
    },
    liabilityData: {
      currentPage: 1,
      totalPages: 1,
    },
    creditData: {
      currentPage: 1,
      totalPages: 1,
    },
  });

  const [tableData, setTableData] = useState({
    assetData: [],
    liabilityData: [],
    creditData: [],
  });

  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      if (["Investment", "Physical"].includes(record.subType)) {
        const res = await fetchData("Asset");
        setTableData((prev) => ({
          ...prev,
          [formatModuleKey("Asset")]: res.records || [],
        }));
      } else {
        const res = await fetchData(record.subType);
        setTableData((prev) => ({
          ...prev,
          [formatModuleKey(record.subType)]: res.records || [],
        }));
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName, page = 1) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: page,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      const pagenum = res.pagination.page;
      const total = res.pagination.total;
      setPaginatedModule((prev) => {
        return {
          ...prev,
          [formatModuleKey(moduleName)]: { currentPage: page, totalPages: Math.ceil(total / 10) },
        };
      });
      setLoading(false);
      return {
        moduleName,
        records,
        pagenum,
        total,
      }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }finally{
      setLoading(false);
    }
  };
  console.log("paginatedModule", paginatedModule);
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const moduleNames = ["Asset", "Liability", "Credit"];
  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});
      console.log("tableDataObj", tableDataObj);
      setTableData(tableDataObj);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const fnEdit = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}`);
  };
  const fnEditLoan = (record) => {
    history.push(`/liabilities_credit_new/attributes/${record.module}/${record.id}`);
  };
  const fnEditCredit = (record) => {
    history.push(`/liabilities_credit_new/attributes/${record.module}/${record.id}`);
  };
  const getMonetaryValueAssets = async () => {
    try {
      setLoading(true);
      setMonetaryValue(0);
      const moduleName = "Assets";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (data && data.data && data.data[0] && data.data[0].monetary && data.data[0].monetary !== null) {
        setMonetaryValue(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      console.log(data);
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const assestTypeColsdata = [
    {
      title: "Asset Type",
      dataIndex: "module",
      key: "assetType",
      render: (text) => text || "N/A",
    },
    {
      title: "Name of Asset",
      dataIndex: "Name of Asset",
      key: "assetsName",
      render: (text) => text || "N/A",
    },
    {
      title: "Account Type",
      dataIndex: "Account Type/Titled",
      key: "accountType",
      render: (text) => text || "N/A",
    },
    {
      title: "Monetary Value",
      dataIndex: "Monetary Value",
      key: "monetaryValue",
      render: (record) =>
        record
          ? `$ ${record.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "--------",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => setDropdown(false)}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    zIndex: "999",
                  }}
                />
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li className="liHover" onClick={() => setDropdown(false)}>
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        if (record["Account Type/Titled"] === "PROPERTY") {
                          history.push(`/inventory_new`);
                        } else {
                          fnEdit(record);
                        }
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  const liabilityTypeColsdata = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      key: "liabilitiesName",
      render: (text) => text || "N/A",
    },
    {
      title: "Financial Institution",
      dataIndex: "Financial Institution",
      key: "financialInstitution",
      render: (text) => text || "N/A",
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      key: "monthlyPayment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Interest Rate",
      dataIndex: "Interest Rate",
      key: "interestRate",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Loan Balance",
      dataIndex: "Loan Balance",
      key: "loanBalance",
      render: (record,row) =>{
        const value = row && row["Loan Balance"] || row["Initial Loan Amount"];
        return value
          ? !isNaN(value)
            ? `${"$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A";}
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon" />
            </div>

            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        fnEditLoan(record);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  const creditColsdata = [
    {
      title: "Name of Credit",
      dataIndex: "module",
      key: "creditName",
      render: (text) => text || "N/A",
    },
    {
      title: "Bank",
      dataIndex: "Name of Issuer",
      key: "bank",
      render: (text) => text || "N/A",
    },
    {
      title: "Last Four",
      dataIndex: "Last Four",
      key: "lastFour",
      render: (record) => (record ? "****" + record : "N/A"),
    },
    {
      title: "Credit Limit",
      dataIndex: "Credit Limit",
      key: "creditLimit",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      key: "monthlyPayment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Interest Rate",
      dataIndex: "Interest Rate (or APR%)",
      key: "interestRate",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Credit Balance",
      dataIndex: "Credit Balance",
      key: "loanBalance",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "$0"
          : "$0",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon" />
            </div>

            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        fnEditCredit(record);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  console.log("tableData", tableData);
  useEffect(() => {
    fetchAllModulesData();
    getMonetaryValueAssets();
    getLiabilitySum();
  }, []);

  return (
    <>
      <div className="assets-container">
        <div className="asset-title-container">
          <h3 className="assets-title">Assets</h3>
        </div>
        <div className="assets-help-icon-container">
          <img src={helpIcon} alt="help-icon" width="18.67" height="18.67px" />
        </div>
      </div>
      <div className="assets-image-container">
        <div className="liability-image">
          <p className="total-liability-title">Total Assets</p>
          <img src={assetImage} alt="assets imag" width="88px" height="105px" />
          <NewLoader isLoading={loading} />
        </div>
        <div className="liability-amount-container">
          <h4 className="liability-amount">${formatAmount(monetaryValue)}</h4>
        </div>
      </div>
      <div className="assets-type-container">
        <div className="assets-type-header-container">
          <h2 className="assets-type-title">Assets</h2>
        </div>
        <div className="assets-type-table-container">
          <Table
            columns={assestTypeColsdata}
            dataSource={tableData.assetData}
            pagination={{
              total: paginatedModule.assetData.totalPages * 10, // Assuming 10 items per page
              current: paginatedModule.assetData.currentPage,
              pageSize: 10,
              onChange: async (page) => {
                console.log("pageeeeeeeeeeee", page);
                const modulName = "Asset";
                setPaginatedModule((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: {
                    ...prev.assetData,
                    currentPage: page,
                  },
                }));
                const res = await fetchData(modulName, page);
                setTableData((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: res.records || [],
                }));
              },
            }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="liability-container">
        <div className="liability-title-container">
          <h3 className="liability-title">Liabilities</h3>
        </div>
        <div className="liability-help-icon-container">
          <img src={helpIcon} alt="help-icon" width="18.67" height="18.67px" />
        </div>
      </div>
      <div className="liability-image-container">
        <div className="liability-image">
          <p className="total-liability-title">Total liabilities</p>
          <img src={liabilityImage} alt="assets imag" width="88px" height="105px" />
        </div>
        <div className="liability-amount-container">
          <h4 className="liability-amount">${formatAmount(totalLoan)}</h4>
        </div>
      </div>
      <div className="loan-type-container">
        <div className="liability-type-header-container">
          <h2 className="loan-type-title">Loans</h2>
        </div>

        <div className="liability-type-table-container">
          <Table
            columns={liabilityTypeColsdata}
            dataSource={tableData.liabilityData}
            pagination={{
              total: paginatedModule.liabilityData.totalPages * 10, // Assuming 10 items per page
              current: paginatedModule.liabilityData.currentPage,
              pageSize: 10,
              onChange: async (page) => {
                console.log("pageeeeeeeeeeee", page);
                const modulName = "Liability";
                setPaginatedModule((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: {
                    ...prev.liabilityData,
                    currentPage: page,
                  },
                }));
                const res = await fetchData(modulName, page);
                setTableData((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: res.records || [],
                }));
              },
            }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="loan-type-container">
        <div className="liability-type-header-container">
          <h2 className="credit-type-title">Credit</h2>
        </div>
        <div className="liability-type-table-container">
          <Table
            columns={creditColsdata}
            dataSource={tableData.creditData}
            pagination={{
              total: paginatedModule.creditData.totalPages * 10, // Assuming 10 items per page
              current: paginatedModule.creditData.currentPage,
              pageSize: 10,
              onChange: async (page) => {
                console.log("pageeeeeeeeeeee", page);
                const modulName = "Credit";
                setPaginatedModule((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: {
                    ...prev.creditData,
                    currentPage: page,
                  },
                }));
                const res = await fetchData(modulName, page);
                setTableData((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: res.records || [],
                }));
              },
            }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </>
  );
}
